/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateShareLinkInput = {
  id: string
}

export type CreateShareLinkMutationVariables = Exact<{
  id: string
  input: Types.CreateShareLinkInput
}>

export type CreateShareLinkMutation = {
  __typename: "Mutation"
  shareLink: { __typename: "ShareLink"; id: string }
}

export const CreateShareLinkDocument = gql`
  mutation CreateShareLink($id: ID!, $input: CreateShareLinkInput!) {
    shareLink: createShareLink(id: $id, input: $input)
      @rest(
        type: "ShareLink"
        method: "POST"
        endpoint: "shareLinks"
        path: "/project-list/projects/{args.id}/share-links"
        bodySerializer: "shareLink"
      ) {
      id
    }
  }
`
export type CreateShareLinkMutationFn = Apollo.MutationFunction<
  CreateShareLinkMutation,
  CreateShareLinkMutationVariables
>

/**
 * __useCreateShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareLinkMutation, { data, loading, error }] = useCreateShareLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateShareLinkMutation,
    CreateShareLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateShareLinkMutation,
    CreateShareLinkMutationVariables
  >(CreateShareLinkDocument, options)
}
export type CreateShareLinkMutationHookResult = ReturnType<
  typeof useCreateShareLinkMutation
>
export type CreateShareLinkMutationResult =
  Apollo.MutationResult<CreateShareLinkMutation>
export type CreateShareLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateShareLinkMutation,
  CreateShareLinkMutationVariables
>
